export default __webpack_public_path__ + "288dba77939dbbb8f1af0d6a0a7385b8.jpg";